import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './HeroComponent.module.css';
import womanImage from '../../../../Images/newLandingPage/hero.jpg';

const HeroComponent = () => {
    const navigate = useNavigate();

    // Small Tagline Animation
    const [tagText, setTagText] = useState('');
    const smallTaglines = [
        "Validated by 100+ Enterprises",
        "24/7 Intelligent Support",
        "Automate Your Workflow",
        "Boost Sales Efficiency"
    ];

    useEffect(() => {
        let isCancelled = false;
        let loopIndex = 0;
        let charIndex = 0;
        let isDeleting = false;
        let typeSpeed = 100;

        const type = () => {
            if (isCancelled) return;

            const currentPhrase = smallTaglines[loopIndex % smallTaglines.length];

            if (isDeleting) {
                setTagText(currentPhrase.substring(0, charIndex - 1));
                charIndex--;
                typeSpeed = 50;
            } else {
                setTagText(currentPhrase.substring(0, charIndex + 1));
                charIndex++;
                typeSpeed = 100;
            }

            if (!isDeleting && charIndex === currentPhrase.length) {
                isDeleting = true;
                typeSpeed = 2000; // Pause at end
            } else if (isDeleting && charIndex === 0) {
                isDeleting = false;
                loopIndex++;
                typeSpeed = 500; // Pause before next word
            }

            setTimeout(type, typeSpeed);
        };

        const timer = setTimeout(type, 500);
        return () => { isCancelled = true; clearTimeout(timer); };
    }, []);

    // Headline Animation
    const [headlineText, setHeadlineText] = useState('');
    const headlinePhrases = [
        "It Never Sleeps", // Changed "That" to "It" for better flow if needed, or keep "That"
        "Scales Instantly",
        "Drives Revenue",
        "Saves Time"
    ];

    useEffect(() => {
        let isCancelled = false;
        let loopIndex = 0;
        let charIndex = 0;
        let isDeleting = false;
        let typeSpeed = 100;

        const type = () => {
            if (isCancelled) return;

            // Prefix static text "That " if we want, or just animate the whole suffix
            const currentPhrase = headlinePhrases[loopIndex % headlinePhrases.length];

            if (isDeleting) {
                setHeadlineText(currentPhrase.substring(0, charIndex - 1));
                charIndex--;
                typeSpeed = 50;
            } else {
                setHeadlineText(currentPhrase.substring(0, charIndex + 1));
                charIndex++;
                typeSpeed = 100;
            }

            if (!isDeleting && charIndex === currentPhrase.length) {
                isDeleting = true;
                typeSpeed = 3000; // Longer pause for headline
            } else if (isDeleting && charIndex === 0) {
                isDeleting = false;
                loopIndex++;
                typeSpeed = 500;
            }

            setTimeout(type, typeSpeed);
        };

        const timer = setTimeout(type, 500);
        return () => { isCancelled = true; clearTimeout(timer); };
    }, []);

    return (
        <section className={styles.hero}>
            <div className={styles.container}>
                <div className={styles.content}>
                    <div className={styles.tagline}>🚀 {tagText}<span className={styles.cursor}>|</span></div>
                    <h1 className={styles.headline}>
                        The AI Workforce <br />
                        <span className={styles.highlight}>{headlineText}<span className={styles.cursor}>|</span></span>
                    </h1>
                    <p className={styles.subheadline}>
                        Deploy autonomous AI agents that handle sales calls, support tickets, and scheduling—24/7. No coding required.
                        Experience the power of the future, today.
                    </p>
                    <div className={styles.ctaGroup}>
                        <button onClick={() => navigate("/login")} className={styles.primaryBtn}>
                            Start Free Trial
                        </button>
                        <button onClick={() => navigate("/demo-form")} className={styles.secondaryBtn}>
                            Book Demo
                        </button>
                    </div>
                </div>

                <div className={styles.visuals}>
                    <div className={styles.imageWrapper}>
                        <img src={womanImage} alt="AI Agent" className={styles.heroImage} />
                        <div className={styles.overlayGradient}></div>
                    </div>

                    <div className={styles.glassCard}>
                        {/* Mock UI Elements */}
                        <div className={styles.statRow}>
                            <div className={styles.statIcon}>📞</div>
                            <div className={styles.statText}>
                                <h4>Auto-Dialing</h4>
                                <p>Active Campaign: Real Estate Leads</p>
                            </div>
                        </div>
                        <div className={styles.statRow}>
                            <div className={styles.statIcon}>🧠</div>
                            <div className={styles.statText}>
                                <h4>Lead Qualified</h4>
                                <p>Score: 9.8/10 (High Intent)</p>
                            </div>
                        </div>
                        <div className={styles.statRow} style={{ marginBottom: 0 }}>
                            <div className={styles.statIcon} style={{ background: '#10b981' }}>✅</div>
                            <div className={styles.statText}>
                                <h4>Appointment Set</h4>
                                <p>Calendar Sync: Tomorrow at 2:00 PM</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroComponent;